import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Models
import { getHocDisplayName } from 'utils/Tools';
import { isAllowed, getAllUserPermissions } from 'models/permission';
// Custom

const withPermissions = (WrappedComponent, options = {}) => {
  const { withRef = false } = options;

  class WithPermissions extends React.Component {
    constructor(props) {
      super(props);

      this.hasPermission = this.hasPermission.bind(this);
    }

    getWrappedInstance() {
      return withRef ? this.wrappedInstance : null;
    }

    hasPermission(permissions) {
      const {
        isAdmin,
        meFeatures,
        carparkPermissions,
        installationPermissions,
        devicePermissions,
        userPermissions,
      } = this.props;

      return isAllowed(permissions, {
        isAdmin,
        meFeatures,
        carparkPermissions,
        installationPermissions,
        devicePermissions,
        userPermissions,
      });
    }

    render() {
      const { ...otherProps } = this.props;

      return (
        <WrappedComponent
          hasPermission={this.hasPermission}
          ref={
            withRef
              ? (wi) => {
                this.wrappedInstance = wi;
              }
              : null
          }
          {...otherProps}
        />
      );
    }
  }

  WithPermissions.displayName = getHocDisplayName(
    'WithPermissions',
    WrappedComponent,
  );

  WithPermissions.propTypes = {
    isAdmin: PropTypes.bool,
    meFeatures: PropTypes.arrayOf(PropTypes.string),
    carparkPermissions: PropTypes.arrayOf(PropTypes.string),
    installationPermissions: PropTypes.arrayOf(PropTypes.string),
    devicePermissions: PropTypes.arrayOf(PropTypes.string),
    userPermissions: PropTypes.arrayOf(PropTypes.string),
  };

  WithPermissions.defaultProps = {
    isAdmin: false,
    meFeatures: [],
    carparkPermissions: [],
    installationPermissions: [],
    devicePermissions: [],
    userPermissions: [],
  };

  const mapStateToProps = (state) => ({
    isAdmin: state.me.isAdmin,
    meFeatures: state.me.features,
    carparkPermissions: _get(state, 'cpmCarpark.current.data.permissions'), // Do not forget to reset this value by managing REINIT_AUTH action in corresponding reducer!
    installationPermissions: _get(state, 'installation.permissions'),
    devicePermissions: _get(state, 'device.permissions'),
    userPermissions: getAllUserPermissions(_get(state.me.data, 'permissions')),
  });

  return connect(mapStateToProps, null, null, { withRef })(WithPermissions);
};

export default withPermissions;



// WEBPACK FOOTER //
// ./hocs/WithPermissions.js